import { c as _c } from "react/compiler-runtime";
import { useTranslation } from '@/hooks/use-translation';
import { DEMO_KEY_COUNT, demoDesigned, demoMeasured } from './demo-sample';
import { dotsPath, linePath, plotY, type PlotBox } from './plot';
const BOX: PlotBox = {
  from: 0,
  height: 110,
  max: 25,
  min: -10,
  to: DEMO_KEY_COUNT - 1,
  width: 300,
  x: 10,
  y: 30
};

/**
 * What the keys should weigh to land on a chosen balance weight.
 *
 * The measurements sit low and flat, the computed curve sweeps down across
 * the keyboard: the gap between the two is the lead to move, which is what
 * the page is offering to work out.
 */
export const FrontWeightPreview = () => {
  const $ = _c(17);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("The measured front weight of the demonstration piano under the target curve computed from a chosen balance weight.");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d={`M0 ${plotY(BOX, 0)}H320`} strokeWidth="1" strokeDasharray="2 3" fill="none" className="stroke-input" />;
    t2 = <path d={dotsPath(demoMeasured.frontWeight, BOX, 1.4)} opacity="0.7" className="fill-ptl-series-balance" />;
    t3 = <path d={linePath(demoDesigned.frontWeight, BOX)} strokeWidth="2.2" fill="none" className="stroke-ptl-brass" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("computed front weight");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <text x="12" y="22" className="fill-ptl-brass font-mono text-[9.5px]">{t4}</text>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("measured");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <text x="12" y="132" className="fill-ptl-ink-3 font-mono text-[9.5px]">{t6}</text>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t0 || $[14] !== t5 || $[15] !== t7) {
    t8 = <svg viewBox="0 0 320 150" className="block min-h-0 w-full flex-1" role="img" aria-label={t0}>{t1}{t2}{t3}{t5}{t7}</svg>;
    $[13] = t0;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};